import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from '../../../shared/seo/canonical.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-bulk-mailing',
  imports: [MatCardModule,MatIconModule,CommonModule,FormsModule,RouterModule],
  templateUrl: './bulk-mailing.component.html',
  styleUrl: './bulk-mailing.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BulkMailingComponent {

    constructor(private titleService: Title, private metaService: Meta,private canonicalService: CanonicalService) { }

tools = [
  {
    icon: 'bi-megaphone-fill',
    title: 'Build Campaigns Your Way',
    desc: 'Design and customize email campaigns that match your brand and audience needs.'
  },
  {
    icon: 'bi-calendar-check-fill',
    title: 'Flexible Workflows',
    desc: 'Save time with automated workflows tailored to your marketing strategy.'
  },
  {
    icon: 'bi-people-fill',
    title: 'Smart Segmentation',
    desc: 'Target the right audience with advanced segmentation and personalization.'
  },
  {
    icon: 'bi-graph-up-arrow',
    title: 'Test & Optimize',
    desc: 'Experiment, analyze, and improve campaigns for better engagement and results.'
  },
  {
    icon: 'bi-bar-chart-fill',
    title: 'Real-time Analytics',
    desc: 'Gain actionable insights with live data and performance tracking.'
  },
  {
    icon: 'bi-patch-check-fill',
    title: 'Proven Deliverability',
    desc: 'Ensure your emails reach inboxes with industry-leading delivery systems.'
  }
];

ngOnInit(): void {
  // Set page title
  this.titleService.setTitle('Bulk Email Marketing | Send Campaigns at Scale - MALtech');

  // Set meta description
  this.metaService.updateTag({
    name: 'description',
    content: 'Bulk email marketing helps you reach a large audience with personalized campaigns, improve engagement, boost conversions, and grow your business efficiently.'
  });

  // SEO enhancements
  this.metaService.updateTag({ name: 'robots', content: 'index, follow' });

  // Canonical URL
  this.canonicalService.setCanonicalURL('product/bulk-email/');
}


 faqsLeft = [
    {
      question: 'Should I outsource my email marketing activities?',
      answer: `If you have the time and resources to design, write, test, and edit your own marketing emails in house, then go ahead and do so. However, if you'd rather delegate such responsibilities to an expert, outsourcing is the way to go. We at Maltech would be delighted to assist you with your email marketing efforts! We can assist you with developing a successful email marketing strategy and then implementing it for you, so all you have to do is sit back and reap the rewards.`,
      open: false
    },
    {
      question: 'What can I do to keep my emails from being filtered as spam?',
      answer: `If you wish to avoid the spam folder, there are several clear email marketing Do's and Don'ts, such as writing in all caps. However, spam filters are far more sophisticated now than they were in the past, so a couple of missteps normally won't spell the end for you. The simplest method to avoid ending up in the spam folder is to write like a friend rather than a salesperson–the tone of your emails, as well as the vocabulary you employ, will inevitably be different.`,
      open: false
    },
    {
      question: 'What does the CAN-SPAM law say?',
      answer: `This regulation mandates that anyone sending commercial emails include an unsubscribe link in each one, as well as the company's physical address or P.O. Box, and to honor any subscriber's request to unsubscribe by never emailing them again. Noncompliance with the regulation might result in fines of up to $300 per email recipient.`,
      open: false
    }
  ];

  faqsRight = [
    {
      question: 'Email deliverability and Email open rates: what do these mean?',
      answer: `Email Deliverability: The most important part of your email marketing is email deliverability. Your campaign will be ineffective if your emails are not delivered. It is critical for a successful email marketing campaign that your emails reach your users' inboxes. Deliverability allows you to track how well your emails made it to your recipients' inboxes. This list excludes emails that ended up in the spam or junk folders, as well as emails that bounced.
Open Rates: The word "Open Rate" refers to the total number of people on your mailing list who have opened your emails. It is typically expressed as a percentage. The open rate of your email campaign is a key indicator. This percentage will assist you in determining the effectiveness of your email campaign. The disadvantage of depending solely on the open rate percentage is that it does not account for the real quantity of emails delivered. It's a percentage that adds up over time. Another thing to remember is that the open rate cannot be determined solely by the HTML text read. Many users save images, which are an important part of the email once again. Many people merely scan through emails instead of reading them thoroughly.`,
      open: false
    },
    {
      question: 'How does a spam filter work?',
      answer: `Spam filters do not provide complete security. However, if you don't use it, you're more likely to become a victim of a scam. Spamming is a multi billion business that isn't going away anytime soon.
Before labeling them as spam, a spam filter coupled with your mailing system evaluates many factors.
Content Filters: It will examine the content of the email.
Header Filters: It will look for any false information in the header.
General blacklist filters: It will block all emails that come from known spammers' blacklisted files.
Users-defined criteria: A certain word in a subject line, is taken into account by rule-based filters.
Permission filters: This will necessitate the recipients' permission to receive emails from a specific sender.
Challenge-response filters: This type of filter needs you to enter a code before sending an email to receive the recipients' consent.`,
      open: false
    },
    {
      question: 'What are the metrics used to measure the success of an e-mail campaign?',
      answer: `The open rate and click through rate are the two most essential indicators in email marketing. Subscribers will never read your entire marketing message if they don't open your emails, and if they do open them but don't click through to your site, your emails aren't converting.`,
      open: false
    }
  ];

  toggle(item: any) {
    item.open = !item.open;
  }
}
